import { lazy as l } from 'react';

export const AcceptInvitePage = l(() => import('~/domain/user-invites/pages/AcceptInvitePage'));

export const AppRedirect = l(() => import('~/core/pages/AppRedirect'));

export const OidcStartContainer = l(() => import('~/domain/auth/pages/StartContainer'));

export const OidcCallbackContainer = l(() => import('~/domain/auth/pages/CallbackContainer'));

export const OperatorLandingPageContainer = l(
  () => import('~/components/containers/OperatorLandingPageContainer/OperatorLandingPageContainer')
);

export const SalescompanyLogin = l(
  () => import('~/components/containers/SalescompanyLogin/SalescompanyLogin')
);

export const ISIMCodeValidatorContainer = l(
  () => import('~/components/containers/ISIMCodeValidatorContainer/ISIMCodeValidatorContainer')
);

export const SignupPage = l(() => import('~/domain/sign-up/pages/SignupPage'));

export const SignupCompletePage = l(
  () => import('~/domain/sign-up/pages/SignupCompletePage/SignupCompletePage')
);

export const RegistrationPage = l(() => import('~/domain/sign-up/pages/RegistrationPage'));

export const CompanySettingsContainer = l(
  () => import('~/domain/company/pages/CompanySettingsContainer/CompanySettingsContainer')
);

export const ChangeLogContainer = l(
  () => import('~/domain/changelog/pages/ChangeLogContainer/ChangeLogContainer')
);

export const DashboardContainer = l(
  () => import('~/domain/dashboard/pages/DashboardContainer/DashboardContainer')
);

export const DataExportsContainer = l(
  () => import('~/components/containers/DataExportsContainer/DataExportsContainer')
);

export const DealerAccessContainer = l(
  () => import('~/components/containers/DealerAccessContainerV2/DealerAccessContainerV2')
);

export const GatewaysContainer = l(
  () => import('~/components/containers/GatewaysContainer/GatewaysContainer')
);

export const LegalDocumentsContainer = l(
  () => import('~/components/containers/LegalDocumentsContainer/LegalDocumentsContainer')
);

export const InventoryRouteWrapper = l(
  () => import('~/domain/inventory-list/components/InventoryRouteWrapper/InventoryRouteWrapper')
);

export const RoboticMowerInstallationContainer = l(
  () =>
    import(
      '~/domain/roboticmower-details/components/RoboticMowerInstallation/RoboticMowerInstallation'
    )
);

export const UserManagementContainer = l(
  () => import('~/components/containers/UserManagementContainer/UserManagementContainer')
);

export const UsersAndAccessContainer = l(
  () => import('~/components/containers/UsersAndAccessContainer/UsersAndAccessContainer')
);

export const ExpediteInviteRequestsContainer = l(
  () =>
    import(
      '~/components/containers/ExpediteInviteRequestsContainer/ExpediteInviteRequestsContainer'
    )
);

export const EnableAccessGroupsContainer = l(
  () => import('~/components/containers/EnableAccessGroupsContainer/EnableAccessGroupsContainer')
);

export const CookiePolicyPage = l(
  () => import('~/domain/legal/pages/CookiePolicyPage/CookiePolicyPage')
);

export const UptimeCallbackContainer = l(
  () => import('~/domain/uptime/pages/UptimeCallbackContainer')
);
export const UptimeLogoutContainer = l(() => import('~/domain/uptime/pages/UptimeLogoutContainer'));

export const GreenkeeperRoutes = l(
  () => import('~/domain/greenkeeper-tool/routes/GreenkeeperRoutes')
);
